import React from "react";

const TextModal = ({ text1, text2, varieties = [] }) => {
  return (
    <>
      <p
        style={{
          fontSize: "16px",
          lineHeight: "1.5rem",
          fontWeight: "normal",
          color: "#0D0040",
        }}
      >
        {text1}
        <span
          style={{
            fontSize: "16px",
            fontWeight: 500,
            color: "#0D0040",
          }}
        >
          {varieties.length === 1 && ` - ${varieties[0]}`}
        </span>
      </p>
      {text2 !== undefined && (
        <p
          style={{
            fontSize: "16px",
            fontWeight: "normal",
            color: "#0D0040",
          }}
        >
          {text2}
        </p>
      )}
    </>
  );
};

export default TextModal;
